(() => {
  const updateConsumerSpecs = (root) => {
    const systemGroup = root.querySelector('[aria-labelledby^="SpecsV2Group4-"]');
    const list = systemGroup?.querySelector("dl");

    if (list) {
      const findRow = (label) =>
        Array.from(list.children).find(
          (row) => row.querySelector("dt")?.textContent.trim().toLowerCase() === label.toLowerCase()
        );

      const processorValue = findRow("Processor")?.querySelector("dd");
      if (processorValue) {
        processorValue.textContent = "Quad-core ARM Cortex-A53";
      }

      let audioRow = findRow("Audio capture");
      if (!audioRow) {
        audioRow = document.createElement("div");

        const audioLabel = document.createElement("dt");
        audioLabel.textContent = "Audio capture";

        const audioValue = document.createElement("dd");
        audioValue.textContent = "Dual SiSonic™ digital microphones";

        audioRow.append(audioLabel, audioValue);
        list.append(audioRow);
      } else {
        const audioValue = audioRow.querySelector("dd");
        if (audioValue) {
          audioValue.textContent = "Dual SiSonic™ digital microphones";
        }
      }
    }

    const structuredData = root.querySelector('script[type="application/ld+json"]');
    if (!structuredData) return;

    try {
      const product = JSON.parse(structuredData.textContent);
      const properties = Array.isArray(product.additionalProperty)
        ? product.additionalProperty
        : [];

      const upsertProperty = (name, value) => {
        const property = properties.find(
          (item) => item?.name?.toLowerCase() === name.toLowerCase()
        );

        if (property) {
          property["@type"] = "PropertyValue";
          property.name = name;
          property.value = value;
        } else {
          properties.push({ "@type": "PropertyValue", name, value });
        }
      };

      upsertProperty("Processor", "Quad-core ARM Cortex-A53");
      upsertProperty("Audio capture", "Dual SiSonic™ digital microphones");
      product.additionalProperty = properties;
      structuredData.textContent = JSON.stringify(product);
    } catch (error) {
      console.warn("8ight specs structured data could not be updated.", error);
    }
  };

  const init = (root) => {
    if (!root || root.dataset.specsInitialized === "true") return;
    root.dataset.specsInitialized = "true";

    updateConsumerSpecs(root);

    let toggle = document.querySelector("[data-sunglasses-toggle]");
    let observer;
    let sunImage = root.querySelector("[data-sun-src]");
    let sunImageReady = Boolean(sunImage?.currentSrc || sunImage?.getAttribute("src"));
    let sunImagePromise;

    const loadSunglassesImage = () => {
      if (!sunImage || sunImageReady) return Promise.resolve();
      if (sunImagePromise) return sunImagePromise;

      const source = sunImage.dataset.sunSrc;
      if (!source) return Promise.resolve();

      sunImagePromise = new Promise((resolve) => {
        let settled = false;
        const settle = (success) => {
          if (settled) return;
          settled = true;
          sunImageReady = success;
          sunImage.classList.toggle("is-ready", success);
          if (!success) sunImagePromise = undefined;
          resolve(success);
        };
        const decodeAndSettle = () => {
          if (typeof sunImage.decode === "function") {
            sunImage.decode().then(() => settle(true)).catch(() => settle(false));
          } else {
            settle(true);
          }
        };

        sunImage.addEventListener("load", decodeAndSettle, { once: true });
        sunImage.addEventListener("error", () => settle(false), { once: true });
        sunImage.src = source;
        sunImage.removeAttribute("data-sun-src");

        if (sunImage.complete) decodeAndSettle();
      });

      return sunImagePromise;
    };

    const syncSunglasses = async () => {
      const currentToggle = document.querySelector("[data-sunglasses-toggle]");
      if (currentToggle !== toggle) {
        observer?.disconnect();
        toggle = currentToggle;
        if (toggle) observer?.observe(toggle, { attributes: true, attributeFilter: ["aria-pressed"] });
      }

      const requestedActive = toggle?.getAttribute("aria-pressed") === "true";
      if (requestedActive) await loadSunglassesImage();
      const stillActive = toggle?.getAttribute("aria-pressed") === "true";
      root.dataset.sunglassesActive = String(stillActive && sunImageReady);
      if (stillActive && !sunImageReady && sunImage) {
        sunImage.dataset.sunSrc ||= sunImage.currentSrc || sunImage.src;
        sunImage.removeAttribute("src");
      }
    };

    const onToggleClick = (event) => {
      if (event.target.closest?.("[data-sunglasses-toggle]")) {
        requestAnimationFrame(syncSunglasses);
      }
    };

    observer = new MutationObserver(syncSunglasses);
    if (toggle) {
      syncSunglasses();
      observer.observe(toggle, { attributes: true, attributeFilter: ["aria-pressed"] });
    }
    document.addEventListener("click", onToggleClick);

    root.specsV2Cleanup = () => {
      observer?.disconnect();
      document.removeEventListener("click", onToggleClick);
      delete root.dataset.specsInitialized;
    };
  };

  const initAll = (scope = document) => scope.querySelectorAll("[data-specs-root]").forEach(init);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll("[data-specs-root]").forEach((root) => root.specsV2Cleanup?.());
  });
})();
